<template>
  <div>
    <!-- ===== TEAM ===== -->
    <div class="section text-center" id="team">
      <span class="ws-eyebrow">Organisatie</span>
      <h2 class="ws-h2 mt-3 mb-10">Ons team</h2>
      <div class="team ws-stagger" v-reveal>
        <div
          class="ws-card ws-card--hover team-card ws-reveal"
          v-for="(member, i) in team"
          :key="i"
          :style="{ '--i': i }"
        >
          <v-img
            height="110"
            width="110"
            cover
            class="team-photo"
            :src="member.img"
            :alt="`Foto van ${member.name}`"
          ></v-img>
          <h3 class="team-name">{{ member.name }}</h3>
          <p class="team-role" v-if="member.role">{{ member.role }}</p>
        </div>
      </div>
    </div>

    <!-- ===== BELEID ===== -->
    <div class="section" id="beleid">
      <div class="text-center">
        <span class="ws-eyebrow">Transparantie</span>
        <h2 class="ws-h2 mt-3 mb-10">Beleid</h2>
      </div>
      <div class="quick ws-reveal" v-reveal>
        <div class="ws-card">
          <h3 class="card-title">Hoofdlijnen beleidsplan</h3>
          <p class="ws-lead card-text">
            Ontdek meer over onze aanpak en hoe wij gezinnen ondersteunen.
          </p>
          <button class="ws-btn ws-btn--ghost mt-2" @click="openPlan">
            Bekijk het plan →
          </button>
        </div>
        <div class="ws-card">
          <h3 class="card-title">Beloningsbeleid</h3>
          <p class="ws-lead card-text">
            De leden van het Bestuur genieten geen beloning voor hun
            werkzaamheden. Zij hebben wel recht op een niet bovenmatige
            vergoeding van de door hen in de uitoefening van hun functie
            gemaakte kosten.
          </p>
        </div>
        <div class="ws-card">
          <h3 class="card-title">Uitgeoefende activiteiten</h3>
          <p class="ws-lead card-text">
            2025 was het eerste operationele jaar van de stichting. Een eerste
            gezin met een ernstig ziek kind heeft van een vakantie genoten en
            wij zijn samenwerkingen met zakelijke partners aangegaan. Zie ons
            ANBI-verslag 2025 voor de details.
          </p>
        </div>
        <div class="ws-card">
          <h3 class="card-title">Financiële verantwoording</h3>
          <p class="ws-lead card-text">
            De financiële verantwoording over 2025 is opgenomen in ons
            ANBI-verslag 2025, inclusief de balans en de staat van baten en
            lasten.
          </p>
        </div>
      </div>
    </div>

    <!-- ===== ANBI VERSLAG ===== -->
    <div class="section" id="anbi">
      <div class="text-center">
        <span class="ws-eyebrow">Verantwoording</span>
        <h2 class="ws-h2 mt-3 mb-10">ANBI verslag 2025</h2>
      </div>
      <div class="d-flex justify-center">
        <div class="ws-card text-center anbi-card ws-reveal" v-reveal>
          <p class="ws-lead">
            In ons ANBI-verslag 2025 leggen wij publiekelijk verantwoording af
            over het eerste operationele jaar van Stichting WeShare4Kids. Het
            verslag bevat onze doelstelling en beleid, een overzicht van de
            uitgevoerde activiteiten en de volledige financiële verantwoording
            met de balans en de staat van baten en lasten over 2025.
          </p>
          <button
            class="ws-btn ws-btn--primary mt-6 mx-auto"
            @click="openAnbiReport"
          >
            Download verslag
          </button>
        </div>
      </div>
    </div>

    <PartnerSection />
  </div>
</template>

<script>
import PartnerSection from "@/components/PartnerSection.vue";
import { useMeta } from "vue-meta";

export default {
  components: {
    PartnerSection,
  },
  setup() {
    useMeta({
      title: "Organisatie",
    });
  },
  data() {
    return {
      team: [
        {
          name: "Gerard van Kaathoven",
          role: "Voorzitter",
          img: require("@/assets/team/gerard.jpeg"),
        },
        {
          name: "Jos van Haaren",
          role: "Secretaris - Penningmeester",
          img: require("@/assets/team/jos.jpeg"),
        },
        {
          name: "Jan Aussems",
          role: "Lid",
          img: require("@/assets/team/jan.jpeg"),
        },
        {
          name: "Antoinette Janssen",
          role: "",
          img: require("@/assets/team/antoinette.jpg"),
        },
      ],
    };
  },
  methods: {
    openPlan() {
      let url = "/Beleidsplan.pdf";
      window.open(url, "_blank"); //to open in new tab
    },
    openAnbiReport() {
      let url = "/ANBI-verslag-2025.pdf";
      window.open(url, "_blank"); //to open in new tab
    },
  },
};
</script>

<style lang="scss" scoped>
.team {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}
.team-card {
  align-items: center;
  text-align: center;
}
.team-photo {
  border-radius: 18px;
  flex: 0 0 auto;
}
.team-name {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 18px;
  color: #241b12;
  margin-top: 16px;
}
.team-role {
  font-size: 14.5px;
  color: #8a7c6f;
  margin-top: 6px;
}

.quick {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}
.card-title {
  font-family: "Nunito", sans-serif;
  font-weight: 800;
  font-size: 20px;
  color: #241b12;
  margin-bottom: 11px;
}
.card-text {
  font-size: 15px;
  flex: 1;
}

.anbi-card {
  max-width: 700px;
  align-items: center;
  padding: 40px 38px;
}

@media screen and (max-width: 900px) {
  .team {
    grid-template-columns: 1fr 1fr;
  }
  .quick {
    grid-template-columns: 1fr 1fr;
  }
}
@media screen and (max-width: 600px) {
  .team,
  .quick {
    grid-template-columns: 1fr;
  }
}
</style>
